import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showHCCfields: false,
    selectedHCCValue: 'No',
    giveHCCdiscount: false,
    selectedSMValue: 'No',
    selectedSDValue: 'No',
    selectedEBDValue: 'No',
    selectedMCValue: 'No',
    selectedDiscount: '',
    selectedStaffDiscount: 'No',
    FTE: 0,
    SDPER: 0,
    EmployeeId: 0,
    isHCCUploaded: false,
    isAgreementChecked: false,
    hasSubmitted: false,
    showEarlyBirdDisc: false,
    parentMultiCollegeDetails: [],
    hccSelections: [],
    hccExpiry: '',
    hccImages: [],
};

const reenrolmentSlice = createSlice({
    name: 'reenrolment',
    initialState,
    reducers: {
        setHCCInfo: (state, action) => {
            state.showHCCfields = action.payload.showHCCfields;
            state.selectedHCCValue = action.payload.selectedHCCValue;
            state.giveHCCdiscount = action.payload.giveHCCdiscount;
            state.isHCCUploaded = action.payload.isHCCUploaded;
            state.hccSelections = action.payload.hccSelections;
            state.hccExpiry = action.payload.hccExpiry;
            state.hccImages = action.payload.hccImages;
        },
        setDiscountInfo: (state, action) => {
            state.selectedSMValue = action.payload.selectedSMValue;
            state.selectedSDValue = action.payload.selectedSDValue;
            state.selectedEBDValue = action.payload.selectedEBDValue;
            state.selectedMCValue = action.payload.selectedMCValue;
            state.selectedDiscount = action.payload.selectedDiscount;
            state.selectedStaffDiscount = action.payload.selectedStaffDiscount;
        },
        setEmployeeInfo: (state, action) => {
            state.FTE = action.payload.FTE;
            state.SDPER = action.payload.SDPER;
            state.EmployeeId = action.payload.EmployeeId;
        },
        setFormStatus: (state, action) => {
            state.isAgreementChecked = action.payload.isAgreementChecked;
            state.hasSubmitted = action.payload.hasSubmitted;
        },
        setEarlyBirdDiscount: (state, action) => {
            state.showEarlyBirdDisc = action.payload;
        },
        setMultiCollegeDetails: (state, action) => {
            state.parentMultiCollegeDetails = action.payload;
        },
        clearReenrolment: (state) => {
            return initialState;
        },
    },
});

export const {
    setHCCInfo,
    setDiscountInfo,
    setEmployeeInfo,
    setFormStatus,
    setEarlyBirdDiscount,
    setMultiCollegeDetails,
    clearReenrolment,
} = reenrolmentSlice.actions;

export default reenrolmentSlice.reducer;